(() => {
  if (window.RareTCGCartState) return;

  const listeners = new Set();
  let latestState = null;
  let refreshPromise = null;
  let refreshController = null;

  const cartRoute = () => `${window.Shopify?.routes?.root || '/'}cart.js`;

  function normalize(cart) {
    if (!cart || typeof cart.item_count !== 'number') return null;

    return {
      item_count: Math.max(0, Number(cart.item_count) || 0),
      items_subtotal_price: Number(cart.items_subtotal_price ?? cart.total_price) || 0,
      total_price: Number(cart.total_price) || 0,
      sections: cart.sections || {},
      raw: cart,
    };
  }

  function notify(state, source) {
    if (!state) return null;
    latestState = state;
    listeners.forEach((listener) => listener(state, source));
    return state;
  }

  async function refresh(source = 'fallback') {
    if (refreshPromise) return refreshPromise;

    refreshController?.abort();
    refreshController = new AbortController();

    refreshPromise = fetch(cartRoute(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: refreshController.signal,
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => notify(normalize(cart), source))
      .catch((error) => {
        if (error.name !== 'AbortError') console.error('[RareTCG] Cart state refresh failed:', error);
        return latestState;
      })
      .finally(() => {
        refreshPromise = null;
        refreshController = null;
      });

    return refreshPromise;
  }

  function consume(event = {}) {
    const state = normalize(event.cartData || event.cart || event.detail?.cart);
    if (state) return Promise.resolve(notify(state, event.source || 'cart-update'));
    return refresh(event.source || 'cart-update-fallback');
  }

  function subscribeState(listener) {
    listeners.add(listener);
    if (latestState) listener(latestState, 'current');
    return () => listeners.delete(listener);
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, consume);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh('bfcache');
  });

  window.RareTCGCartState = {
    consume,
    get: () => latestState,
    refresh,
    subscribe: subscribeState,
  };
})();
